import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import CallLogsApi from '../generated/api/CallLogs';

export default (service: Servicelayer) => ({
  ...CallLogsApi(service),

  // Add custom calls here

});
